import { Injectable } from '@angular/core';
import { Departamento, Funcionario } from '../api.service';
import { consultaFiltroDepartamento, funcionariosNoRecorteDepartamento } from './filtro-departamento';

@Injectable({ providedIn: 'root' })
export class ServicoFiltroDepartamento {
  consulta(idsSelecionados: string[], totalDepartamentos: number) {
    return consultaFiltroDepartamento(idsSelecionados, totalDepartamentos);
  }

  funcionariosNoRecorte(funcionarios: Funcionario[], idsSelecionados: string[], departamentos: Departamento[]) {
    return funcionariosNoRecorteDepartamento(funcionarios, idsSelecionados, departamentos.length);
  }
}
